import { System } from '../../data/types/system/system';

export const getSystemUniqueId = (system: System) =>
  `${system.nameIndex}.${system.coordinates.X}.${system.coordinates.Y}`;
